import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { AES, enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";
import swal from "sweetalert";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Alert from "@mui/material/Alert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./OrderTracking.css";
import PurchaseBillsNew from "../Purchases/PurchaseBillsNew";
import NewReceiptNote from "../Receipt Note/NewReceiptNote";
import NewPurchaseOrder from "../Purchases/NewPurchaseOrder";
import NewVendorEnquiry from "../Vendor Enquiry/NewVendorEnquiry";
import AddIndentNew from "../Indent/AddIndentNew";

const ProcurementTracking = ({
  customerName,
  customerId,
  batchNo,
  type,
  navigation,
  handleCancel,
}) => {
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);
  const jwtToken = localStorage.getItem("jwtToken");

  const [loading, setLoading] = useState(false);
  const [showTrackProcurement, setShowTrackProcurement] = useState(true);
  const [showIndent, setShowIndent] = useState(false);
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [showPurchaseOrder, setShowPurchaseOrder] = useState(false);
  const [showPurchaseBill, setShowPurchaseBill] = useState(false);
  const [showReceiptNote, setShowReceiptNote] = useState(false);
  const [activePopup, setActivePopup] = useState(null);
  const [stepStatuses, setStepStatuses] = useState([]);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [activeStepIndex, setActiveStepIndex] = useState(0);

  // File states for each step
  const [indentFiles, setIndentFiles] = useState([]);
  const [enquiryFiles, setEnquiryFiles] = useState([]);
  const [initialFollowUpFiles, setInitialFollowUpFiles] = useState([]);
  const [quotationFiles, setQuotationFiles] = useState([]);
  const [purchaseOrderFiles, setPurchaseOrderFiles] = useState([]);
  const [purchaseFollowUpFiles, setPurchaseFollowUpFiles] = useState([]);
  const [receiptNoteFiles, setReceiptNoteFiles] = useState([]);
  const [purchaseBillFiles, setPurchaseBillFiles] = useState([]);

  // Modal states
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [showMessagesModal, setShowMessagesModal] = useState(false);
  const [isMessageSubmitted, setIsMessageSubmitted] = useState(false);
  const [followUpMessages, setFollowUpMessages] = useState([]);

  const [messageTitle, setMessageTitle] = useState("");
  const [messageContent, setMessageContent] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [newValidationMessage, setValidationMessage] = useState("");

  const [showPurchaseFollowUpModal, setShowPurchaseFollowUpModal] =
    useState(false);
  const [showPurchaseMessagesModal, setShowPurchaseMessagesModal] =
    useState(false);
  const [isPurchaseMessageSubmitted, setIsPurchaseMessageSubmitted] =
    useState(false);
  const [purchaseFollowUpMessages, setPurchaseFollowUpMessages] = useState([]);

  const procurementSteps = [
    ...(type !== "fromVendorEnquiry"
      ? [
          {
            title: "Indent",
            icon: "file-alt",
            tooltip: "Create indent for required items",
          },
        ]
      : []),
    {
      title: "Purchase Enquiry",
      icon: "envelope-open-text",
      tooltip: "Send enquiries to vendors for required items",
    },
    {
      title: "Follow-up",
      icon: "calendar-check",
      tooltip: "Track and follow up for vendor responses",
    },
    {
      title: "Purchase Quotation",
      icon: "file-signature",
      tooltip: "Collect quotations from vendors",
    },
    {
      title: "Purchase Order (PO)",
      icon: "file-contract",
      tooltip: "Create and share a PO with the selected vendor",
    },
    {
      title: "Purchase Followup",
      icon: "calendar-check",
      tooltip: "Follow up for material delivery",
    },
    {
      title: "Receipt Note",
      icon: "clipboard-check",
      tooltip: "Generate a Receipt Note for received items",
    },
    {
      title: "Purchase Bill",
      icon: "file-invoice-dollar",
      tooltip: "Generate the purchase bill for vendor payment",
    },
  ];

  const fetchProcurementDetails = () => {
    setLoading(true);
    fetch(BASE_URL + `/getVendorFollowUp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        trackingNo: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          const statusData = data.responseMessage;
          const statuses =
            type !== "fromVendorEnquiry"
              ? [
                  statusData.indent,
                  statusData.purchaseEnquiry,
                  statusData.followUp,
                  statusData.purchaseQuotation,
                  statusData.purchaseOrder,
                  statusData.purchaseFollowUp,
                  statusData.receiptNote,
                  statusData.purchaseBill,
                ]
              : [
                  statusData.purchaseEnquiry,
                  statusData.followUp,
                  statusData.purchaseQuotation,
                  statusData.purchaseOrder,
                  statusData.purchaseFollowUp,
                  statusData.receiptNote,
                  statusData.purchaseBill,
                ];

          // Set the step statuses
          setStepStatuses(statuses);

          // Calculate the active step (next one after the last "completed" step)
          const lastCompletedStepIndex = statuses.findIndex(
            (status) => status !== "completed"
          );
          setActiveStepIndex(
            lastCompletedStepIndex === -1
              ? statuses.length - 1
              : lastCompletedStepIndex
          );
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch Follow-up details:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
        setLoading(false);
      });
  };

  const getFollowupMessages = () => {
    const followupData = {
      uniqueId: decryptedUniqueId,
      trackingNo: batchNo,
      type: "followup",
    };
    setLoading(true);
    fetch(BASE_URL + `/getVendorFollowUpMessage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(followupData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.responseCode === "200") {
          setFollowUpMessages(data.data);
          setLoading(false);
        } else {
          console.error("Failed to fetching follow-up:", data.responseMessage);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error submitting follow-up:", error);
        setLoading(false);
        swal({
          icon: "error",
          title: "Error fetching follow-up",
        });
        return;
      });
  };

  const getAllFiles = () => {
    setLoading(true);
    fetch(BASE_URL + `/getDocumentsByInquiry`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("procurment files : ", data);
        setIndentFiles(data.indentFile ? [data.indentFile] : []);
        setEnquiryFiles(
          data.purchaseEnquiryFile ? [data.purchaseEnquiryFile] : []
        );
        setInitialFollowUpFiles(
          data.initialFollowUpFile ? [data.initialFollowUpFile] : []
        );
        setQuotationFiles(
          data.purchaseQuotationFile ? [data.purchaseQuotationFile] : []
        );
        setPurchaseOrderFiles(
          data.purchaseOrderFile ? [data.purchaseOrderFile] : []
        );
        setPurchaseFollowUpFiles(
          data.purchaseFollowUpFile ? [data.purchaseFollowUpFile] : []
        );
        setReceiptNoteFiles(data.receiptNoteFile ? [data.receiptNoteFile] : []);
        setPurchaseBillFiles(
          data.purchaseBillFile ? [data.purchaseBillFile] : []
        );
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching sales order files:", error);
        setLoading(false);
      });
  };

  const insertFile = (file, stepType) => {
    const formData = new FormData();

    let endpoint = "/addVendorFollowUpFiles";
    let fileTypeName = "";

    // Determine the endpoint based on the step type
    switch (stepType) {
      case "Follow-up":
        fileTypeName = "followup";
        break;
      case "Purchase Quotation":
        fileTypeName = "purchasequotation";
        break;
      case "Purchase Order (PO)":
        fileTypeName = "purchaseorder";
        break;
      case "Purchase Followup":
        endpoint = "purchasefollowup";
        break;
      case "Receipt Note":
        fileTypeName = "receiptnote";
        break;
      default:
        console.error("Unknown step type for file upload");
        return;
    }

    const fileData = {
      uniqueId: decryptedUniqueId,
      inquiryId: batchNo,
      type: fileTypeName,
    };

    // formData.append("requestBody", JSON.stringify(fileData));
    formData.append("uniqueId", decryptedUniqueId);
    formData.append("inquiryId", batchNo);
    formData.append("type", fileTypeName);
    formData.append("file", file);

    setLoading(true);
    fetch(BASE_URL + endpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("file uploaded : ", data);
        if (data.status == "success") {
          setLoading(false);
          fetchProcurementDetails();
          getAllFiles();
          swal({
            icon: "success",
            title: "File uploaded successfully",
          });
        } else {
          console.error("Failed to upload file:", data.message);
          setLoading(false);
          swal({
            icon: "error",
            title: "Failed to upload file",
          });
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setLoading(false);
        swal({
          icon: "error",
          title: "Error uploading file",
        });
      });
  };

  const validateForm = () => {
    let newValidationMessage = "";

    if (!messageTitle.trim()) {
      newValidationMessage += "Title is required";
    } else if (!messageContent.trim()) {
      newValidationMessage += "Message content is required";
    } else if (!selectedDate) {
      newValidationMessage += "Please select a follow-up date";
    }

    setValidationMessage(newValidationMessage);
    return newValidationMessage === "";
  };

  const insertFollowupMessage = (msgType) => {
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    const followupData = {
      uniqueId: decryptedUniqueId,
      trackingNo: batchNo,
      title: messageTitle,
      message: messageContent,
      nextFollowUpDate: selectedDate.toISOString(),
      // currentDate: new Date().toISOString(),
      type: msgType,
    };
    setLoading(true);
    fetch(BASE_URL + `/addVendorFollowUpMessage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(followupData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          getFollowupMessages();
          if (msgType === "followup") {
            setIsMessageSubmitted(true);
          } else if (msgType === "purchasefollowup") {
            setIsPurchaseMessageSubmitted(true);
          }
          setLoading(false);
          setMessageTitle("");
          setMessageContent("");
          setSelectedDate(null);
          swal({
            icon: "success",
            title: "Follow-up message submitted successfully",
          });
        } else {
          console.error("Failed to submit follow-up:", data.responseMessage);
          setLoading(false);
          setMessageTitle("");
          setMessageContent("");
          setSelectedDate(null);
          swal({
            icon: "error",
            title: "Failed to submit follow-up",
          });
        }
      })
      .catch((error) => {
        console.error("Error submitting follow-up:", error);
        setLoading(false);
        setMessageTitle("");
        setMessageContent("");
        setSelectedDate(null);
        swal({
          icon: "error",
          title: "Error submitting follow-up",
        });
      });
  };

  const scheduleFollowup = (submitType) => {
    const followupData = {
      uniqueId: decryptedUniqueId,
      inquiryId: batchNo,
      type: submitType,
    };

    setLoading(true);
    fetch(BASE_URL + `/updateVendorFollowUp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(followupData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          getFollowupMessages();
          if (submitType === "followup") {
            setIsMessageSubmitted(true);
          } else if (submitType === "purchasefollowup") {
            setIsPurchaseMessageSubmitted(true);
          }
          setLoading(false);
          swal({
            icon: "success",
            title: "Follow-up message submitted successfully",
          });
        } else {
          console.error("Failed to submit follow-up:", data.responseMessage);
          setLoading(false);
          swal({
            icon: "error",
            title: "Failed to submit follow-up",
          });
        }
      })
      .catch((error) => {
        console.error("Error submitting follow-up:", error);
        setLoading(false);
        swal({
          icon: "error",
          title: "Error submitting follow-up",
        });
      });
  };

  const handleStepCompletion = (currentStepIndex) => {
    // Always progress to the next step, but only if not already at the last step
    if (currentStepIndex < procurementSteps.length - 1) {
      setActiveStepIndex(currentStepIndex + 1);
    }

    // Mark the step as completed
    if (!completedSteps.includes(currentStepIndex)) {
      setCompletedSteps((prev) => [...prev, currentStepIndex]);
    }
  };

  useEffect(() => {
    fetchProcurementDetails();
    getFollowupMessages();
    // getAllFiles();
  }, []);

  const [vendorId, setVendorId] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [enqId, setEnqId] = useState("");

  const handleCancelPurchaseBill = () => {
    setShowTrackProcurement(true);
    setShowPurchaseBill(false);
    setShowReceiptNote(false);
    setShowPurchaseOrder(false);
    setShowIndent(false);
    setShowEnquiry(false);
    setVendorId("");
    setVendorName("");
    setEnqId("");
  };

  const handleCancelReceiptNote = () => {
    setShowTrackProcurement(true);
    setShowPurchaseBill(false);
    setShowReceiptNote(false);
    setShowPurchaseOrder(false);
    setShowIndent(false);
    setShowEnquiry(false);
    setVendorId("");
    setVendorName("");
    setEnqId("");
  };

  const handleCancelPurchaseOrder = () => {
    setShowTrackProcurement(true);
    setShowPurchaseBill(false);
    setShowReceiptNote(false);
    setShowPurchaseOrder(false);
    setShowIndent(false);
    setShowEnquiry(false);
    setVendorId("");
    setVendorName("");
    setEnqId("");
  };

  const handleCancelEnquiry = () => {
    setShowTrackProcurement(true);
    setShowPurchaseBill(false);
    setShowReceiptNote(false);
    setShowPurchaseOrder(false);
    setShowEnquiry(false);
    setShowIndent(false);
    setVendorId("");
    setVendorName("");
    setEnqId("");
  };

  const handleCancelIndent = () => {
    setShowTrackProcurement(true);
    setShowPurchaseBill(false);
    setShowReceiptNote(false);
    setShowPurchaseOrder(false);
    setShowIndent(false);
    setShowEnquiry(false);
    setVendorId("");
    setVendorName("");
    setEnqId("");
  };

  const [fileSubmitted, setFileSubmitted] = useState(false);

  const FileUploadStep = ({
    step,
    index,
    activeStepIndex,
    onStepComplete,
    completedSteps,
  }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const circleRef = React.useRef(null);

    const handleCircleClick = (index, stepTitle) => {
      const getFilesForStep = (title) => {
        switch (title) {
          case "Indent":
            return indentFiles;
          case "Purchase Enquiry":
            return enquiryFiles;
          case "Follow-up":
            return initialFollowUpFiles;
          case "Purchase Quotation":
            return quotationFiles;
          case "Purchase Order (PO)":
            return purchaseOrderFiles;
          case "Purchase Followup":
            return purchaseFollowUpFiles;
          case "Receipt Note":
            return receiptNoteFiles;
          case "Purchase Bill":
            return purchaseBillFiles;
          default:
            return [];
        }
      };

      const files = getFilesForStep(stepTitle);
      const hasFiles = files && files.length > 0;

      console.log(`Files for ${stepTitle}:`, files);

      if (hasFiles) {
        const circleElement = document.getElementById(`step-circle-${index}`);
        if (circleElement) {
          const rect = circleElement.getBoundingClientRect();
          setActivePopup({
            index,
            stepType: stepTitle,
            position: {
              top: rect.top + window.scrollY,
              left: rect.left + window.scrollX,
              width: rect.width,
              height: rect.height,
            },
          });
          console.log("Circle element position:", rect);
        }
      }

      if (stepTitle === "Follow-up") {
        setShowMessagesModal(true);
        getFollowupMessages();
      }

      if (stepTitle === "Purchase Bill") {
        if (customerId || customerName || batchNo) {
          setShowTrackProcurement(false);
          setShowPurchaseBill(true);
          setShowReceiptNote(false);
          setShowPurchaseOrder(false);
          setVendorId(customerId);
          setVendorName(customerName);
          setEnqId(batchNo);
        }
      }

      if (stepTitle === "Receipt Note") {
        if (customerId || customerName || batchNo) {
          setShowTrackProcurement(false);
          setShowPurchaseBill(false);
          setShowReceiptNote(true);
          setShowPurchaseOrder(false);
          setVendorId(customerId);
          setVendorName(customerName);
          setEnqId(batchNo);
        }
      }

      if (stepTitle === "Purchase Order (PO)") {
        if (customerId || customerName || batchNo) {
          setShowTrackProcurement(false);
          setShowPurchaseBill(false);
          setShowPurchaseOrder(true);
          setShowReceiptNote(false);
          setVendorId(customerId);
          setVendorName(customerName);
          setEnqId(batchNo);
        }
      }

      if (stepTitle === "Purchase Enquiry") {
        if (customerId || customerName || batchNo) {
          setShowTrackProcurement(false);
          setShowPurchaseBill(false);
          setShowPurchaseOrder(false);
          setShowEnquiry(true);
          setShowReceiptNote(false);
          setVendorId(customerId);
          setVendorName(customerName);
          setEnqId(batchNo);
        }
      }

      if (stepTitle === "Indent") {
        if (customerId || customerName || batchNo) {
          setShowTrackProcurement(false);
          setShowPurchaseBill(false);
          setShowPurchaseOrder(false);
          setShowEnquiry(false);
          setShowIndent(true);
          setShowReceiptNote(false);
          setVendorId(customerId);
          setVendorName(customerName);
          setEnqId(batchNo);
        }
      }
    };

    const handleFileUpload = (e) => {
      const file = e.target.files[0];
      setSelectedFile(file);
    };

    const handleFileSubmit = () => {

      if (index > 0 && stepStatuses[index - 1] !== "completed") {
        swal({
          icon: "warning",
          title: "Complete the previous step",
          text: `Please complete the "${procurementSteps[index - 1].title}" step before submitting this one.`,
        });
        setSelectedFile(null);
        return;
      }

      if (selectedFile) {
        insertFile(selectedFile, step.title);
        onStepComplete(index);
        setFileSubmitted(true);
        setSelectedFile(null);
      }
    };

    const getCircleClassName = () => {
      const stepStatus = stepStatuses[index];
      if (stepStatus === "completed") return "completed";
      if (index === activeStepIndex) return "active";
      return "";
    };

    const renderStepContent = () => {
      if (step.title === "Follow-up") {
        return (
          <div className="d-flex flex-column align-items-center">
            <>
              <div className="d-flex justify-content-center">
                <button
                  className="file-upload-btn mt-2 mx-1"
                  onClick={() => setShowFollowUpModal(true)}
                >
                  <i className="fas fa-comments"></i>
                </button>
                <div className="mx-1">
                  <input
                    type="file"
                    id={`file-step-${index}`}
                    className="file-upload"
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                  />
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mt-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </div>
            </>
            {(isMessageSubmitted || selectedFile) && (
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={() => {

                  if (index > 0 && stepStatuses[index - 1] !== "completed") {
                    swal({
                      icon: "warning",
                      title: "Complete the previous step",
                      text: `Please complete the "${procurementSteps[index - 1].title}" step before submitting this one.`,
                    });
                    return;
                  }

                  
                  if (isMessageSubmitted) {
                    onStepComplete(index);
                    scheduleFollowup("followup");
                  } else if (selectedFile) {
                    handleFileSubmit();
                  }
                }}
              >
                {isMessageSubmitted ? "Submit Followup" : "Submit File"}
              </button>
            )}
          </div>
        );
      }

      if (step.title === "Purchase Followup") {
        return (
          <div className="d-flex flex-column align-items-center">
            <>
              <div className="d-flex justify-content-center">
                <button
                  className="file-upload-btn mt-2 mx-1"
                  onClick={() => setShowPurchaseFollowUpModal(true)}
                >
                  <i className="fas fa-comments"></i>
                </button>
                <div className="mx-1">
                  <input
                    type="file"
                    id={`file-step-${index}`}
                    className="file-upload"
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                  />
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mt-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </div>
            </>
            {(isPurchaseMessageSubmitted || selectedFile) && (
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={() => {

                  if (index > 0 && stepStatuses[index - 1] !== "completed") {
                    swal({
                      icon: "warning",
                      title: "Complete the previous step",
                      text: `Please complete the "${procurementSteps[index - 1].title}" step before submitting this one.`,
                    });
                    return;
                  }

                  if (isPurchaseMessageSubmitted) {
                    onStepComplete(index);
                    scheduleFollowup("purchasefollowup");
                  } else if (selectedFile) {
                    handleFileSubmit();
                  }
                }}
              >
                {isPurchaseMessageSubmitted ? "Submit Followup" : "Submit File"}
              </button>
            )}
          </div>
        );
      }

      if (step.title === "Purchase Quotation") {
        return (
          <div className="d-flex flex-column align-items-center">
            {/* {stepStatuses[index] === "Pending" && ( */}
            <div className="file-upload-wrapper">
              <input
                type="file"
                id={`file-step-${index}`}
                onChange={handleFileUpload}
                style={{ display: "none" }}
              />
              <label
                htmlFor={`file-step-${index}`}
                className="file-upload-btn mt-2"
              >
                <i className="fas fa-upload"></i>
              </label>
              {selectedFile && (
                <span style={{ marginLeft: "10px" }}>{selectedFile.name}</span>
              )}
            </div>
            {/* )} */}
            {selectedFile && (
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
            {fileSubmitted && (
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={() => {
                  scheduleFollowup("purchasequotation");
                  onStepComplete(index);
                }}
              >
                Submit Step
              </button>
            )}
          </div>
        );
      }

      if (step.title === "Purchase Order (PO)") {
        return (
          <div className="d-flex flex-column align-items-center">
            {/* {stepStatuses[index] === "Pending" && ( */}
            <div className="file-upload-wrapper">
              <input
                type="file"
                id={`file-step-${index}`}
                onChange={handleFileUpload}
                style={{ display: "none" }}
              />
              <label
                htmlFor={`file-step-${index}`}
                className="file-upload-btn mt-2"
              >
                <i className="fas fa-upload"></i>
              </label>
              {selectedFile && (
                <span style={{ marginLeft: "10px" }}>{selectedFile.name}</span>
              )}
            </div>
            {/* )} */}
            {selectedFile && (
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
            {fileSubmitted && (
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={() => {
                  scheduleFollowup("purchaseorder");
                  onStepComplete(index);
                }}
              >
                Submit Step
              </button>
            )}
          </div>
        );
      }

      if (step.title === "Receipt Note") {
        return (
          <div className="d-flex flex-column align-items-center">
            {/* {stepStatuses[index] === "Pending" && ( */}
            <div className="file-upload-wrapper">
              <input
                type="file"
                id={`file-step-${index}`}
                onChange={handleFileUpload}
                style={{ display: "none" }}
              />
              <label
                htmlFor={`file-step-${index}`}
                className="file-upload-btn mt-2"
              >
                <i className="fas fa-upload"></i>
              </label>
              {selectedFile && (
                <span style={{ marginLeft: "10px" }}>{selectedFile.name}</span>
              )}
            </div>
            {/* )} */}
            {selectedFile && (
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
            {fileSubmitted && (
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={() => {
                  scheduleFollowup("receiptnote");
                  onStepComplete(index);
                }}
              >
                Submit Step
              </button>
            )}
          </div>
        );
      }

      // For all other steps
      return (
        <div className="d-flex flex-column align-items-center">
          {/* {stepStatuses[index] === "Pending" && ( */}
          <div className="file-upload-wrapper">
            <input
              type="file"
              id={`file-step-${index}`}
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />
            <label
              htmlFor={`file-step-${index}`}
              className="file-upload-btn mt-2"
            >
              <i className="fas fa-upload"></i>
            </label>
            {selectedFile && (
              <span style={{ marginLeft: "10px" }}>{selectedFile.name}</span>
            )}
          </div>
          {/* )} */}
          {selectedFile && (
            <button
              className="btn btn-success btn-sm mt-2"
              onClick={handleFileSubmit}
            >
              Submit
            </button>
          )}
        </div>
      );
    };

    return (
      <div className="step-wrapper step-wrapper-two">
        <div className="step-content">
          <h6 className="step-title">{step.title}</h6>
          <div
            ref={circleRef}
            className={`step-circle ${getCircleClassName()}`}
            id={`step-circle-${index}`}
            onClick={() => handleCircleClick(index, step.title)}
          >
            <i className={`fas fa-${step.icon}`}></i>
            <div className="step-tooltip">{step.tooltip}</div>
          </div>

          {stepStatuses[index] === "completed" && (
            <div className="completed-text">
              <h6 className="text-success">Completed</h6>
            </div>
          )}

          <div className="file-upload-wrapper">{renderStepContent()}</div>
        </div>
      </div>
    );
  };

  const FilePopup = ({ position, onClose, stepType }) => {
    let files = [];
    let filePath = "";

    switch (stepType) {
      case "Indent":
        files = indentFiles;
        break;
      case "Purchase Enquiry":
        files = enquiryFiles;
        break;
      case "Follow-up":
        files = initialFollowUpFiles;
        break;
      case "Purchase Quotation":
        files = quotationFiles;
        break;
      case "Purchase Order (PO)":
        files = purchaseOrderFiles;
        break;
      case "Purchase Followup":
        files = purchaseFollowUpFiles;
        break;
      case "Receipt Note":
        files = receiptNoteFiles;
        break;
      case "Purchase Bill":
        files = purchaseBillFiles;
        break;
      default:
        files = [];
    }

    return (
      <div
        className="action-popup show"
        style={{
          position: "absolute",
          top: position ? `${position.top + position.height - 40}px` : "0",
          left: position
            ? `${position.left + position.width / 2 - 290}px`
            : "0",
        }}
      >
        <button
          className="close-popup-btn"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        <div className="fetched-files">
          {files.length === 0 ? (
            <div className="text-center text-muted">
              <p>No files found.</p>
            </div>
          ) : (
            files.map((fileName, index) => (
              <div className="fetched-file" key={index}>
                <div className="file-info">
                  <div className="file-name">
                    <i className="fas fa-file"></i>
                    <span>{fileName}</span>
                  </div>
                </div>
                <div className="popup-actions">
                  <Button
                    variant="success"
                    className="mx-2"
                    onClick={() =>
                      window.open(
                        `${BASE_URL}/uploads/${filePath}/${fileName}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="fas fa-eye"></i> Preview
                  </Button>
                  <Button
                    variant="primary"
                    className="mx-2"
                    onClick={() =>
                      window.open(
                        `${BASE_URL}/uploads/${filePath}/${fileName}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="fas fa-download"></i> Download
                  </Button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="container-fluid ">
        <div className="page-content">
          <div className="center-div">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {showTrackProcurement && (
        <Container fluid className="py-4">
          <Row className="justify-content-center">
            <Col lg={12} md={12}>
              <div className="my-3">
                <div className="px-2 d-flex align-items-center">
                  <div className="back-button" onClick={handleCancel}>
                    <ArrowBackIosIcon size={20} className="arrow-child" />
                  </div>
                  <h5
                    className="mt-1 mx-2 text-primary"
                    style={{ letterSpacing: "1px" }}
                  >
                    Procurement Tracking
                  </h5>
                </div>
              </div>

              <Card className="card-style">
                {newValidationMessage && (
                  <Alert severity="error" className="mt-0">
                    {newValidationMessage.split("\n").map((message, index) => (
                      <div key={index}>{message}</div>
                    ))}
                  </Alert>
                )}
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h6>
                        Procurement ID :{" "}
                        <span className="mt-1 mx-2 text-primary font-20">
                          {batchNo}
                        </span>{" "}
                      </h6>

                      <h6>
                        Customer Name :{" "}
                        <span className="mt-1 mx-2 text-primary font-20">
                          {customerName}
                        </span>{" "}
                      </h6>
                    </div>
                  </div>

                  <div className="text-center">
                    <div
                      className="main-content-label mb-4"
                      style={{ fontSize: "24px", fontWeight: "bold" }}
                    >
                      Procurement Process Steps
                    </div>
                    <div className="progress-snake">
                      {procurementSteps.map((step, index) => (
                        <FileUploadStep
                          key={index}
                          step={step}
                          index={index}
                          activeStepIndex={activeStepIndex}
                          onStepComplete={handleStepCompletion}
                          completedSteps={completedSteps}
                        />
                      ))}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {activePopup !== null && (
            <FilePopup
              position={activePopup.position}
              onClose={() => setActivePopup(null)}
              stepType={activePopup.stepType}
            />
          )}

          <Modal
            show={showFollowUpModal}
            onHide={() => setShowFollowUpModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Follow-up Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Message Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    className="message-title"
                    placeholder="Enter Message Title"
                    value={messageTitle}
                    onChange={(e) => setMessageTitle(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3 w-100">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    className="form-control message-box"
                    name="description"
                    required
                    value={messageContent}
                    onChange={(e) => setMessageContent(e.target.value)}
                    placeholder="Enter Your Message"
                  />
                </Form.Group>
                <Form.Group className="mb-3 next-followup-date">
                  <Form.Label>Next Follow-up Date</Form.Label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    required
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    minDate={new Date()}
                    placeholderText="Next Follow-Up Date"
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowFollowUpModal(false)}
              >
                Close
              </Button>
              <Button
                variant="primary"
                type="submit"
                onClick={() => {
                  insertFollowupMessage("followup");
                  setShowFollowUpModal(false);
                }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showPurchaseFollowUpModal}
            onHide={() => setShowPurchaseFollowUpModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Purchase Follow-up Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Message Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    className="message-title"
                    placeholder="Enter Message Title"
                    value={messageTitle}
                    onChange={(e) => setMessageTitle(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3 w-100">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    className="form-control message-box"
                    name="description"
                    required
                    value={messageContent}
                    onChange={(e) => setMessageContent(e.target.value)}
                    placeholder="Enter Your Message"
                  />
                </Form.Group>
                <Form.Group className="mb-3 next-followup-date">
                  <Form.Label>Next Follow-up Date</Form.Label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    required
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    minDate={new Date()}
                    placeholderText="Next Follow-Up Date"
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowPurchaseFollowUpModal(false)}
              >
                Close
              </Button>
              <Button
                variant="primary"
                type="submit"
                onClick={() => {
                  insertFollowupMessage("purchasefollowup");
                  setShowPurchaseFollowUpModal(false);
                }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showMessagesModal}
            onHide={() => setShowMessagesModal(false)}
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Follow-Up Messages</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {followUpMessages?.length === 0 ? (
                <div className="text-center text-muted">
                  <p>No follow-up messages.</p>
                </div>
              ) : (
                <ul className="list-unstyled">
                  {followUpMessages?.map((msg) => (
                    <li key={msg.id} className="mb-3 pb-3 border-bottom">
                      <h6>&bull;&nbsp;{msg.title}</h6>
                      <p>{msg.description}</p>
                      <small className="text-muted">
                        {new Date(msg.date).toLocaleString()}
                      </small>
                    </li>
                  ))}
                </ul>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowMessagesModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      )}

      {showPurchaseBill && (
        <PurchaseBillsNew
          onCancel={handleCancelPurchaseBill}
          vendorId={vendorId}
          vendorName={vendorName}
          trackingNo={enqId}
        />
      )}

      {showReceiptNote && (
        <NewReceiptNote
          onCancel={handleCancelReceiptNote}
          vendorId={vendorId}
          vendorName={vendorName}
          trackingNo={enqId}
        />
      )}

      {showPurchaseOrder && (
        <NewPurchaseOrder
          onCancel={handleCancelPurchaseOrder}
          vendorId={vendorId}
          vendorName={vendorName}
          trackingNo={enqId}
        />
      )}

      {showEnquiry && (
        <NewVendorEnquiry
          onCancel={handleCancelEnquiry}
          vendorId={vendorId}
          vendorName={vendorName}
          trackingNo={enqId}
        />
      )}

      {showIndent && (
        <AddIndentNew
          onCancel={handleCancelIndent}
          vendorId={vendorId}
          vendorName={vendorName}
          trackingNo={enqId}
        />
      )}
    </>
  );
};

export default ProcurementTracking;
